import * as React from "react";
import styled from "styled-components";


// import Ripple from 'src/SharedComponents/Ripple';

interface IProps {
    checked: boolean,
    onChange: (checked: boolean) => void,
    color?: string
}

const SwitchContainer = styled.span`
    width: 62px;
    display: inline-flex;
    z-index: 0;
    position: relative;
    flex-shrink: 0;
    vertical-align: middle;
    &:focus {
        & .bar {
            border: 1px solid #187fba;
        }
        & .circle {
            border: 1px solid #187fba;
        }
    }
`;

const Bar = styled.span`
top: 50%;
left: 50%;
width: 34px;
height: 14px;
display: block;
z-index: -1;
opacity: 0.38;
position: absolute;
margin-top: -7px;
transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
margin-left: -17px;
border-radius: 7px;
background-color: #000;
&.checked{
    background-color: #ccc;
}
`;

const CircleContainer = styled.span`
    color: rgb(225, 0, 80);
    transform: translateX(0px);
    width: 48px;
    color: #fafafa;
    height: 48px;
    padding: 0;
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    overflow: visible;
    font-size: 1.5rem;
    text-align: center;
    border-radius: 50%;
    border: 0;
    margin: 0;
    cursor: pointer;
    outline: none;
    position: relative;
    user-select: none;
    vertical-align: middle;
    justify-content: center;
    text-decoration: none;
    background-color: transparent;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    &.checked{
        transform: translateX(14px);
    }
`;

const CircleInnerContainer = styled.span`
width: 100%;
display: flex;
align-items: inherit;
justify-content: inherit;
`;

const Circle = styled.span`
width: 20px;
height: 20px;
box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);
border-radius: 50%;
background-color: #ccc;
&.checked {
    background-color: #fff;
}
`;

const InputBit = styled.input`
top: 0;
left: 0;
width: 100%;
cursor: inherit;
height: 100%;
margin: 0;
opacity: 0;
padding: 0;
position: absolute;
`;

const Switch = (props: IProps) => {
    const { checked, onChange } = props;

    const toggleCheckbox = () => {
        onChange(!checked)
    };

    const onKeyDown = (event: any) => {
        const key = event.key || event.keyCode;
        if (key === " ") {
            toggleCheckbox();
            event.stopPropagation();
            event.preventDefault();
        }
    };

    return <SwitchContainer tabIndex={0} onKeyDown={onKeyDown} onClick={toggleCheckbox}>
        <CircleContainer className={checked ? "checked" : ""}>
            <CircleInnerContainer>
                <Circle className={checked ? "circle checked" : "circle"} />
                <InputBit tabIndex={-1} type="checkbox" defaultChecked={checked} id="more-help-switch" />
            </CircleInnerContainer>
        </CircleContainer>
        <Bar className={checked ? "bar checked" : "bar"} />
    </SwitchContainer>
}

export default Switch;


// WEBPACK FOOTER //
// ./src/SharedComponents/Switch.tsx